var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8BitCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.1 17.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 2.2,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 12.8,
    width: 1.6,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 15,
    width: 1.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 15.4,
    width: 1.6,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.8,
    width: 1.6,
    height: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    width: 1.6,
    height: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 1.6,
    width: 1.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 4.3,
    width: 1.6,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.8,
    y: 3.2,
    width: 11.3,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.8,
    y: 9.6,
    width: 8.1,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 8,
    width: 3.2,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 6.4,
    width: 3.2,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 14.4,
    width: 13,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 1.6,
    width: 2.2,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 3.2,
    width: 2.2,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 9.6,
    width: 2.2,
    height: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    y: 6.4,
    width: 1.6,
    height: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: 8,
    width: 1.6,
    height: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8BitCart);
export default __webpack_public_path__ + "static/media/8-bit_cart.78eb50671b44ba2fb6486e12806e94e2.svg";
export { ForwardRef as ReactComponent };